module.exports = __webpack_public_path__ + "assets/evgoChargeCard.b21f0fcc.svg";